import styled from 'styled-components';

export const Container = styled.ul`
  margin: 32px 0 0;
  padding-left: 20px;
`;

export const Row = styled.li``;
